import React, {useEffect, useRef, useState} from 'react';
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {
    ADD_STATE, REMOVE_STATE, setApp,
    setFilter,
    setForm,
    setItem, setLoading,
    setTableParams, setUdn,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {hotelActivityService} from "../../../../jwt/_services/hotel/hotelActivityService";
import {ActivitySectionForm} from "./_form";
import {Col, Row, Spinner} from "reactstrap";

const ActivitySection = (props) => {
    const path = props?.path + '/activities';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  app, udn, domainObject : parentDomainObject } = parentComponentState?.data || {};
    const {  listDomainObjects } = componentState?.data || [];
    const {  filter, loading, domainObject } = componentState?.data || {};

    const [showFormModal, setShowFormModal] = useState(true);
    const formModalRef = useRef(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        // console.log(domainObject);
        // console.log( !app?.id || !udn?.id || !domainObject?.id || filter)
        if( !app?.id || !udn?.id || !parentDomainObject?.id )
            return

        props.setApp(path, app);
        props.setUdn(path, udn);

        props.setFilter(path , {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                category : { id : parentDomainObject?.id }
            }
        });
    }, [ app, udn, parentDomainObject ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, hotelActivityService, 0, 1000, filter)
    }, [ filter ]);


    useEffect( () => {
        if(!domainObject?.id)
            return

        formModalRef.current.updateData( domainObject, domainObject );
    }, [ domainObject ]);

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);

        setShowFormModal(true);
        formModalRef.current.showModal(null, (listDomainObjects?.length || 0), parentDomainObject);
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        setShowFormModal(true);
        formModalRef.current.showModal(data, (listDomainObjects?.length || 0), parentDomainObject);
    }

    const onRemoveItem = (item) => {
        genericIndexedActions.delete(path, hotelActivityService, item.id, app?.fbDataBase?.id);
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, hotelActivityService, dataRequest)
    }

    const renderContent = (item, index) => {
        return (
            <div className={'sauser-item' + (item.status ? '' : ' innactive')}>
                <h4>{index + 1}</h4>
                <div className={'sub-category-item-image'}>
                    <img className={'image' + (!item?.status ? ' grayscale' : '')}
                         src={item?.mediaUrl}
                         alt={item?.title}
                    />
                </div>
                <label className="sauser-item-title">
                    <b>{item.title}</b>
                    <br />
                    {item?.place?.title}
                </label>
                <div className="float-left">
                    <GenericButton
                        style={'table'}
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={_ => editItem(item, index)}/>
                    <TranslateButton item={item} service={hotelActivityService} askForConfirmation={false}/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => onRemoveItem(item)}
                    />
                </div>
            </div>
        )
    }


    const notImplemented = (item, index) => {
        console.log('Not implemented', item, index);
    }

    return (<>
        {
            loading ? <Spinner animation="border"/> : <>
                <div className={'sub-category-section-activities'}>
                    <Row>
                        <Col>
                            <GenericButton
                                style={'success-secondary'}
                                label={'Agregar actividad'}
                                toolTip={'Agregar actividad'}
                                icon={'fa-plus'}
                                permission={'add'}
                                onClick={_ => createItem()}/>
                        </Col>
                    </Row>

                    {
                        listDomainObjects?.length > 0 &&
                        <DragDropList
                            items={listDomainObjects?.sort((a, b) => {
                                if (a.status === b.status) {
                                    return a.showOrder - b.showOrder;
                                }
                                return b.status - a.status; // Los que tienen status true primero
                            })}
                            renderContent={renderContent}
                            onReorder={onReorder}
                            orientationHV={'vertical-container'} // CSS class para orientar los elementos horizontalmente
                            className={'sub-category-section-list'}
                        />
                    }
                </div>
            </>
        }
        {
            showFormModal && <ActivitySectionForm
                path={path}
                app={app}
                udn={udn}
                category={domainObject}

                ref={formModalRef}
            />
        }
    </>)
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setApp,
    setUdn,
})
export default connect(mapStateToProps, mapActionsToProps)(ActivitySection)